import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { WorkspaceService } from '../../workspace/workspace.service';
import { GridEventService } from './services/grid-event.service';
import { GlobalService } from '../../global/services/global.service';

@Component({
    selector: 'gtw-grid',
    template: `
    @if (screenKey) {
<div class="grid-container">
      <div [attr.id]="'grid_' + screenKey"
           class="gizmo-grid"
           tabindex="2"
           gg-grid
           (ggCallBack)="onGridCallback($event)">
      </div>
    </div>
}
  `,
    styles: [`
    .grid-container {
      width: 100%;
      min-height: 200px;
    }
  `],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class GridComponent implements OnInit, OnDestroy {
  @Input() screenKey: string = '';
  private routeSub!: Subscription;

  constructor(
    private route: ActivatedRoute,
    private workspaceService: WorkspaceService,
    private gridEventService: GridEventService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.routeSub = this.route.params.subscribe((params) => {
      if (params['screenKey']) {
        const key = params['screenKey'];
        if (/^\d+$/.test(key)) {
          this.screenKey = key;
        } else {
          const link = 'workspace.' + key;
          const found = this.workspaceService.findScreenByLink(link);
          if (found) {
            this.screenKey = found.screen.screen_key;
            const currentKey = this.workspaceService.workspaceFactory.activeScreen?.screen_key;
            if (currentKey !== found.screen.screen_key) {
              this.workspaceService.setActivity(found.activity, true, found.screen);
            }
          } else {
            this.screenKey = key;
          }
        }
      } else {
        this.screenKey =
          this.workspaceService.workspaceFactory.activeScreen?.screen_key || '';
      }
    });
  }

  onGridCallback(_event: any): void {}

  ngOnDestroy(): void {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
